
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Loading from "../../../components/loading.vue";

import { ExamV3Tem } from "@/lib/model/exambuilder/exam-v3/exam-v3";
import ModelCard from "@/views/ai-builder-v3/components/modelCard/index.vue";
import UploadImgV3 from "@/components/UploadImg-ai-v3.vue";
import { TemplateList } from "@/lib/newExam/template";

@Component({
  components: { UploadImgV3, Loading, ModelCard }
})
export default class SetBasicTem extends Vue {
  @Prop({ type: ExamV3Tem, default: null })
  exam!: ExamV3Tem;
  @Prop({ type: String, default: "" })
  tacToken!: string;
  @Prop({ type: String, default: "" })
  nameBackup!: string;

  dataReady = false;
  loading = false;

  formData = { name: "", remark: "", coverUrl: "", description: "" };
  rules = {
    name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
    coverUrl: [{ required: true, message: "请上传封面", trigger: "blur" }],
    description: [
      { required: true, message: "请输入模板介绍 ", trigger: "blur" }
    ]
  };

  // 输入长度校验方法
  validateInputMaxLength(e: any, value: string, max: number) {
    if (value.length !== max || e.keyCode < 48 || e.keyCode > 90) return;

    this.$message.warning(`已达到${max}个字，无法继续输入！`);
  }

  async created() {
    this.initData();
    this.dataReady = true;
  }

  //上传图片
  uploaded(d: any) {
    this.formData.coverUrl = d;
    this.onDataChange();
  }

  @Watch("exam")
  initData() {
    this.formData.name = this.exam.templateName;
    this.formData.remark = this.exam.templateRemark;
    this.formData.coverUrl = this.exam.coverUrl;
    this.formData.description = this.exam.description;
  }

  //离开前数据校验
  async checkData() {
    let res = true;

    // 表单
    (this.$refs["form"] as any)?.validate((valid: any) => (res = valid));

    if (!res) {
      this.$nextTick(() => {
        const isError = document.querySelector(".is-error") as HTMLElement;
        isError &&
          isError.scrollIntoView({ block: "center", behavior: "smooth" });
      });
    }

    // 当名称修改后，校验重复
    if (this.formData.name !== "" && this.nameBackup !== this.formData.name) {
      const listRes = await TemplateList.tacGet(
        this.tacToken,
        this.formData.name
      );

      if (listRes.count > 0) {
        res = false;
        this.$message.error("模板名称重复");
      }
    }

    return res;
  }

  onDataChange() {
    this.exam.templateName = this.formData.name;
    this.exam.templateRemark = this.formData.remark;
    this.exam.coverUrl = this.formData.coverUrl;
    this.exam.description = this.formData.description;
    this.change();
    (this.$refs["form"] as any)?.clearValidate("coverUrl");
  }

  @Emit()
  change() {
    return;
  }
}
